<ng-container *ngIf="(eligibleCheckInBound$ | async) === undefined">
  <div
    *ngIf="promotion$ | async as promotion"
    class="ps-medium mr-large-b rounded-large shadow"
    [class.white-bg]="promotion.type === 'info'"
    [class.alert-50-bg]="promotion.type === 'alert'"
  >
    <h2 class="font-heading-4 nordic-blue-900-text">
      {{ promotion.header.headerTranslationKey | finLocalization: promotion.header.headerParams }}
    </h2>

    <div
      *ngIf="promotion.contentTranslationKey"
      class="font-body-1 nordic-blue-900-text pr-xsmall-t content-block"
      [innerHTML]="promotion.contentTranslationKey | finLocalization"
    ></div>
    <div class="fill align-right ps-small-t" *ngIf="promotion.linkTextTranslationKey && promotion.linkClickAction">
      <fcom-button
        [text]="promotion.linkTextTranslationKey | finLocalization"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [mode]="ButtonMode.FILL_MOBILE"
        [icon]="promotion.icon"
        (clickBtn)="linkClick(promotion)"
      >
      </fcom-button>
    </div>
    <cms-unstyled-fragment
      *ngIf="promotion.fragmentUrl"
      [contentUrl$]="promotion.fragmentUrl | finLocalization | finToObservable"
      class="block pr-xsmall-t"
    ></cms-unstyled-fragment>
  </div>
</ng-container>

<fin-check-in-trigger
  class="block mr-large-b"
  *ngIf="(eligibleCheckInBound$ | async) !== undefined"
  [mode]="'block'"
  [order]="order$ | async"
  [bound]="eligibleCheckInBound$ | async"
></fin-check-in-trigger>
